<template>
  <v-card class="meal-card" outlined elevation="1" height="120px">
    <div class="d-flex" style="height: 100%">
      <!-- Meal Image - Full Height Left Side -->
      <div class="meal-image-container">
        <v-img
          v-if="meal.image && meal.image.host && meal.image.name"
          :src="mealImageUrl"
          :alt="meal.name"
          aspect-ratio="1"
          class="meal-image"
        >
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-icon color="grey" large>mdi-food</v-icon>
            </div>
          </template>
        </v-img>
        <div v-else class="meal-image d-flex align-center justify-center grey lighten-4">
          <v-icon color="grey" large>mdi-food-variant</v-icon>
        </div>
      </div>

      <!-- Content and Controls - Right Side -->
      <div class="meal-content d-flex flex-column justify-space-between flex-grow-1">
        <!-- Meal Info -->
        <div class="pa-3 pb-1">
          <div class="font-weight-medium text-body-2 text--primary mb-1">
            {{ meal.name }}
          </div>
          <div class="text-caption text--secondary">ID: {{ meal.id }}</div>
        </div>

        <!-- Quantity Controls -->
        <div class="pa-3 pt-1">
          <div class="d-flex align-center">
            <circle-button
              icon="mdi-minus"
              @click="decreaseQuantity"
              :disabled="currentQuantity <= 0"
              color="primary"
            />
            <text-field
              :value="currentQuantity"
              @input="updateQuantity"
              type="number"
              min="0"
              class="quantity-input mx-2"
              dense
              hide-details
              style="max-width: 60px"
            ></text-field>

            <circle-button icon="mdi-plus" color="primary" @click="increaseQuantity" />
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MealOrderCard",
  props: {
    meal: {
      type: Object,
      required: true,
    },
    shiftKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentQuantity() {
      return this.meal.orders[this.shiftKey] || 0;
    },
    mealImageUrl() {
      if (this.meal.image && this.meal.image.host && this.meal.image.name) {
        return `${this.meal.image.host}/gallery/${this.meal.image.restaurant_id}/medium/${this.meal.image.name}`;
      }
      return null;
    },
  },
  methods: {
    increaseQuantity() {
      const newQuantity = this.currentQuantity + 1;
      this.updateQuantity(newQuantity);
    },

    decreaseQuantity() {
      if (this.currentQuantity > 0) {
        const newQuantity = this.currentQuantity - 1;
        this.updateQuantity(newQuantity);
      }
    },

    updateQuantity(value) {
      const quantity = parseInt(value) || 0;
      this.$emit("quantity-changed", {
        meal: this.meal,
        shiftKey: this.shiftKey,
        quantity: quantity,
      });
    },
  },
};
</script>

<style scoped>
.meal-card {
  transition: all 0.2s ease;
  border-radius: 8px !important;
  overflow: hidden;
}

.meal-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px);
}

.meal-image-container {
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}

.meal-image {
  width: 100%;
  height: 100%;
  border-radius: 8px 0 0 8px;
}

.meal-content {
  min-width: 0; /* Allows text to truncate properly */
}

.quantity-input >>> .v-input__control {
  min-height: 32px !important;
  height: 32px !important;
  max-height: 32px !important;
}

.quantity-input >>> .v-text-field__details {
  display: none;
}

.quantity-input .v-text-field__slot,
.quantity-input .v-input__control,
.quantity-input .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
  max-height: 32px !important;
}

.quantity-input >>> input {
  text-align: center;
  font-weight: 600;
  font-size: 14px;
}
</style>
